export function getFileNameFromUrl(url) {
  if (!url) return null;
  const urlObj = new URL(url);
  const pathname = urlObj.pathname;

	if (!pathname) return null;
  return pathname.substring(pathname.lastIndexOf('/') + 1);
}

export function getExtensionFromUrl(url) {
  if (!url) return null;
	const filename = getFileNameFromUrl(url);
	return filename.substring(filename.lastIndexOf(".") + 1);
}